import axios from '../lib/axios';

export const getMessageTemplates = () => axios.get('/api/message-templates');

export const createMessageTemplate = (data) => axios.post('/api/message-templates', data);

export const updateMessageTemplate = (id, data) => axios.put(`/api/message-templates/${id}`, data);

export const deleteMessageTemplate = (id) => axios.delete(`/api/message-templates/${id}`);
